import dayjs from "dayjs";

export function getMonth(month = dayjs().month(), year = dayjs().year()) {
  month = Math.floor(month);
  year = Math.floor(year);
  const firstDayOfTheMonth = dayjs(new Date(year, month, 1)).day();
  // Calculate offset so weeks start on Monday
  const firstDayOffset = firstDayOfTheMonth === 0 ? 6 : firstDayOfTheMonth - 1;
  let currentMonthCount = 0 - firstDayOffset;
  const daysMatrix = new Array(6).fill([]).map(() => {
    return new Array(7).fill(null).map(() => {
      currentMonthCount++;
      return dayjs(new Date(year, month, currentMonthCount));
    });
  });
  return daysMatrix;
}


